// import "antd/dist/antd.css";
import './assets/vendors/style' // css
import './App.css'
import './index.css'
import './helpers/i18n'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { StoresProvider, stores } from './stores'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from 'styled-components'
import theme from './helpers/theme'
import { I18nextProvider } from 'react-i18next'
import i18n from './helpers/i18n'

ReactDOM.render(
   <React.StrictMode>
      <I18nextProvider i18n={i18n}>
         <StoresProvider value={stores}>
            <ThemeProvider theme={theme}>
               <BrowserRouter>
                  <App />
               </BrowserRouter>
            </ThemeProvider>
         </StoresProvider>
      </I18nextProvider>
   </React.StrictMode>,
   document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
